import React, { useState, useEffect } from 'react';
import { Search, Bell, User } from 'lucide-react';

const Navbar = ({ onSearch }) => {
  const [scrolled, setScrolled] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 0);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    onSearch(query);
  };

  return (
    <nav className={`fixed top-0 w-full z-50 transition-all duration-300 ${
      scrolled ? 'bg-[#141414]' : 'bg-gradient-to-b from-black to-transparent'
    }`}>
      <div className="flex items-center justify-between px-8 py-4">
        <div className="flex items-center space-x-8">
          <h1 className="text-[#E50914] text-3xl font-bold tracking-tight">
            PORTFOLIO<span className="text-white">FLIX</span>
          </h1>
          <div className="hidden md:flex space-x-6 text-sm">
            <a href="#home" className="text-white hover:text-gray-300 transition">Home</a>
            <a href="#experience" className="text-white hover:text-gray-300 transition">Experience</a>
            <a href="#skills" className="text-white hover:text-gray-300 transition">Skills</a>
          </div>
        </div>

        <div className="flex items-center space-x-6">
          <div className="relative">
            {searchOpen ? (
              <input
                type="text"
                value={searchQuery}
                onChange={handleSearch}
                placeholder="Search by company, role, or tech..."
                className="bg-black/70 border border-white/50 text-white px-4 py-2 pl-10 rounded w-64 focus:outline-none focus:border-white transition-all"
                autoFocus
                onBlur={() => !searchQuery && setSearchOpen(false)}
              />
            ) : null}
            <Search
              className="text-white cursor-pointer hover:text-gray-300 transition absolute left-2 top-1/2 -translate-y-1/2"
              size={20}
              onClick={() => setSearchOpen(!searchOpen)}
            />
          </div>
          <Bell className="text-white cursor-pointer hover:text-gray-300 transition" size={20} />
          <div className="w-8 h-8 bg-[#E50914] rounded flex items-center justify-center cursor-pointer hover:bg-[#f40612] transition">
            <User size={20} className="text-white" />
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;